export const isFeatureOn = (featureName: string) => {
  const featureFlag = `VUE_APP_FEATURE_${featureName}`;
  if (process.env.NODE_ENV === 'development') console.info(`Feature ${featureName} is set to ${process.env[featureFlag]}`);
  return process.env[featureFlag];
};
